import { type } from "arktype";

export const authLoginSchema = type({
	email: type("string.email").configure({
		message: (ctx) =>
			ctx.data ? "The email address is invalid." : "The email address is required.",
	}),
	password: type("string")
		.moreThanLength(0)
		.configure({ message: () => "The password is required." }),
});

export type AuthLoginInput = typeof authLoginSchema.infer;
